import { render, staticRenderFns } from "./Col2WithInfoBox.vue?vue&type=template&id=19de223e&"
import script from "./Col2WithInfoBox.vue?vue&type=script&lang=js&"
export * from "./Col2WithInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./Col2WithInfoBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports